exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-bbb7b648]{text-align:center;border-bottom:1px solid #e9eaec;position:relative;margin-bottom:20px}.list .link[data-v-bbb7b648]{font-size:16px;margin:0 20px;color:#495060;line-height:60px;height:60px;cursor:pointer;display:inline-block}.list .link.active[data-v-bbb7b648]{color:#0bb27a;border-bottom:2px solid #0bb27a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bbb7b648","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/view/setting/corp/corpView.vue
// module id = BJKN
// module chunks = 131